<template>
  <a
    href="#"
    loading="lazy"
    class="manage-cookies text-small"
    @click.prevent="onManageCookiesClick"
  >
    Manage Cookies
  </a>
</template>

<script>
import mixins from '@/utils/mixins'

export default {
  name: 'FooterManageCookies',
  mixins: [mixins.oneTrust],
  methods: {
    onManageCookiesClick() {
      /**
       * Manual scroll fixes the following issue:
       * https://ultimategroup.atlassian.net/browse/FMP-19995
       *
       * Note: OneTrust scrolls to the top upon opening anyway. But for some
       * reason, when video banner is present on the page (above the footer),
       * the page is only partially scrolled to the top, which results in this
       * glitch
       */
      window.scrollTo(0, 0)

      this.$_oneTrust_toggleCookiePreferencesPopup()
    }
  }
}
</script>

<style lang="scss" scoped>
.manage-cookies {
  color: $c--main;
  cursor: pointer;
}
</style>
